module.exports = __webpack_public_path__ + "static/media/014.8e5529b6.jpg";